import { render, staticRenderFns } from "./openPlayer.vue?vue&type=template&id=03bea92e&scoped=true"
import script from "./openPlayer.vue?vue&type=script&lang=js"
export * from "./openPlayer.vue?vue&type=script&lang=js"
import style0 from "./openPlayer.vue?vue&type=style&index=0&id=03bea92e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bea92e",
  null
  
)

export default component.exports